import { renderToStaticMarkup } from 'react-dom/server'
import { type ResourceModel, type TemplateColumnConfig } from '@bryntum/schedulerpro'
import { selectUserConfiguration } from '@/features/domain/user'
import { store } from '@/store'
import { intl } from '@/intl'

import { OrdersExecutedCell } from '../../../components/cells/OrdersExecutedCell'
import { ordersExecutedSorter } from '../sorters/ordersExecutedSorter'

export function createOrdersExecutedColumn(
  width: string | number,
  hidden: boolean,
): Partial<TemplateColumnConfig> {
  return {
    text: intl.translate({ id: 'rm.scheduler.column.ordersExecuted' }),
    type: 'template',
    field: 'ordersExecuted',
    width,
    editor: false,
    hidden,
    region: 'cols',

    template: ({ record, field, value }) => {
      const state = store.getState()
      const { language } = selectUserConfiguration(state)

      return renderToStaticMarkup(
        <OrdersExecutedCell
          record={record as ResourceModel}
          field={field}
          value={value}
          language={language}
        />,
      )
    },

    sortable: ordersExecutedSorter,
    resizable: true,
    groupable: false,
  }
}
